import React from 'react';
import styles from './MerkmaleFilter.module.css';
import cx from 'classnames';
import MultiSelect from '../../../../components/MultiSelect';
import { SelectOption } from '../../../../components/MultiSelect';
import { Merkmal, SelectedMerkmal } from '../../../../types/Merkmal';

interface MerkmaleFilterProps {
    merkmale?: Merkmal[];
    isActive?: boolean;
    selectedMerkmale?: SelectedMerkmal[];
    onMerkmaleChange?: (merkmale: SelectedMerkmal[]) => void;
}

const MerkmaleFilter: React.FC<MerkmaleFilterProps> = ({
    merkmale = [],
    isActive = false,
    selectedMerkmale = [],
    onMerkmaleChange
}) => {

    const handleMerkmalChange = (merkmalId: number, selectedValues: string[]) => {
        if (!onMerkmaleChange) return;

        const filtered = selectedMerkmale.filter(m => m.kMerkmal !== merkmalId);
        
        const newSelections: SelectedMerkmal[] = selectedValues
            .filter(v => v !== '')
            .map(v => ({
                kMerkmal: merkmalId,
                kMerkmalWert: parseInt(v)
            }));

        onMerkmaleChange([...filtered, ...newSelections]);
    };

    const getSelectedValues = (merkmalId: number): string[] => {
        return selectedMerkmale
            .filter(m => m.kMerkmal === merkmalId)
            .map(m => m.kMerkmalWert.toString());
    };

    if (!isActive) {
        return null;
    }

    if (merkmale.length === 0) {
        return null;
    }

    return (
        <div className={cx(styles['merkmale-filter-container'])}>
            <div className={cx(styles['merkmale-filter-list'])}>
                {merkmale.map((merkmal) => {
                    const options: SelectOption[] = merkmal.values.map(wert => ({
                        value: wert.id.toString(),
                        label: wert.name
                    }));

                    const selected = getSelectedValues(merkmal.id);

                    return (
                        <div key={merkmal.id} className={cx(styles['merkmale-group'])}>
                            <MultiSelect
                                options={options}
                                onChange={(property, value, single) => {
                                    const selectedArray = value && value.trim() !== '' 
                                        ? value.split(',').filter(v => v.trim() !== '')
                                        : [];
                                    handleMerkmalChange(merkmal.id, selectedArray);
                                }}
                                property={`merkmal_${merkmal.id}`}
                                selected={selected}
                                placeholder={merkmal.name}
                                className={cx(styles['merkmale-select'])}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MerkmaleFilter;

